export default __webpack_public_path__ + "static/media/prev-E1A-5.24b21039.png";